import { FormControl, FormHelperText, FormLabel, Grid } from '@mui/material';
import { FC } from 'react';
import { TextFieldWithDataReferences } from '../../../../../../Components/Wysiwyg';
import { StepDto } from '../../../../../../dtos';
import { SmartValueListItem } from './SmartValueSlice';

export interface INameInputProps {
    fieldErrors: Map<keyof StepDto, string>;
    name: string;
    handleNameChange: (name: string) => void;
    smartValues: SmartValueListItem[];
}

export const NameInput: FC<INameInputProps> = (props) => {
    const { fieldErrors, name, handleNameChange, smartValues } = props;

    return (
        <Grid item xs={12}>
            <FormControl error={!!fieldErrors.get('name')} fullWidth required>
                <FormLabel>Name</FormLabel>
                <TextFieldWithDataReferences initialValue={name} onChange={handleNameChange} dataReferences={smartValues.map(sv => sv.value)} />
                <FormHelperText>{fieldErrors.get('name')}</FormHelperText>
            </FormControl>
        </Grid>
    );
};
